import project_1Img from "../../../assets/gifs/fancy_loading_animation.gif";
import project_2Img from "../../../assets/gifs/addaGhor.gif";
import project_3Img from "../../../assets/gifs/snakeGame.gif";
import project_4Img from "../../../assets/gifs/banglaWordPrediction.gif";
import project_5Img from "../../../assets/gifs/imageSearch.gif";
import './ProjectinfoLayout.css'
const ProjectInfoLayout = () => {
    const projectsInfo = {
      project_1: {
        id: "1",
        name: "Fancy-Loading-Animation",
        type: "NPM package",
        stack: "React, npm component",
        details:
          "The package contains some fancy looking loading animation components to use in react project. There are many usefull props to easily customize the component to meet any need.",
      },
      project_2: {
        id: "2",
        name: "AddaGhor",
        type: "Messaging App",
        stack:
          "React, firebase, google-authentication, context-api, chatengine",
        details:
          "This is a simple room-based messaging App. Here users can create rooms and invite other users to join and discuss different issues.",
      },
      project_3: {
        id: "3",
        name: "Snake-Game",
        type: "Game",
        stack: "Vanila Javascript",
        details:
          "A simple game that we all know and love: Snake-Game. It has scoring system with options to manage difficulty and snake size",
      },
      project_4: {
        id: "4",
        name: "Bangla Word Prediction",
        type: "Machine Learning Project",
        stack: "Python, Tensorflow, GRU, LSTM, chatengine",
        details:
          "Goal of this work is to take Bengali one or more words as input in a system and predict the next most likely word using Recurrent Neural Network (RNN) with Gated Recurrent Unit (GRU)",
      },
      project_5: {
        id: "5",
        name: "Image Searching Engine",
        type: "Searching image",
        stack: "react, axios, unsplash",
        details:
          "Here anyone can search for an image gallery with some keyword and I've used Unsplash API to get some images corresponding to the search value and show them in a gallery format.",
      },
      project_6: {
        id: "6",
        name: "Video Searching Engine",
        type: "Searching Video",
        stack: "react, axios, youtube API",
        details:
        "Here anyone can search for a video with some keyword and I've used youtube API to get some videos corresponding to the search value and show them in a playable format."
      },
    };
    return (
      <>
        <main class="modify-main">
          {/* <main class="main"> */}

          <section class="card-area">
            {/* <!-- Card: Project_1 --> */}
            <section class="card-section">
              <div class="card">
                <div class="flip-card">
                  <div class="flip-card__container">
                    <div class="card-front">
                      <div
                        className={`card-front__tp card-front__tp--${projectsInfo.project_1.id}`}
                      >
                        <h2 class="card-front__heading">
                          {projectsInfo.project_1.name}
                        </h2>
                        <p class="card-front__type-text">
                          {projectsInfo.project_1.type}
                        </p>
                        <p class="card-front__stack-text">
                          {projectsInfo.project_1.stack}
                        </p>
                      </div>

                      <div class="card-front__bt">
                        <p
                          class={`card-front__text-view card-front__text-view--${projectsInfo.project_1.id}`}
                        >
                          HOVER ME
                        </p>
                      </div>
                    </div>
                    <div class="card-back">
                      <img
                        src={project_1Img}
                        alt="FancyLoadingAnimation"
                        className="video__container"
                        // style={{position: 'absolute'}}
                      />
                      <a
                        href="https://omorfarukrakib.github.io/fancy-loading-animation/"
                        target="_blank"
                        class={`inside-page__btn view-demo-btn inside-page__btn--${projectsInfo.project_1.id}`}
                      >
                        View Demo
                      </a>
                      {/* <video class="video__container" autoplay muted loop>
                                    <source class="video__media" src="https://player.vimeo.com/external/370331493.sd.mp4?s=e90dcaba73c19e0e36f03406b47bbd6992dd6c1c&profile_id=139&oauth2_token_id=57447761" type="video/mp4">
                                </video> */}
                    </div>
                  </div>
                </div>

                <div class="inside-page">
                  <div class="inside-page__container">
                    <h3
                      class={`inside-page__heading inside-page__heading--${projectsInfo.project_1.id}`}
                    >
                      About the package
                    </h3>
                    <p class="inside-page__text">
                      {projectsInfo.project_1.details}
                    </p>
                    <a
                      href="https://www.npmjs.com/package/fancy-loading-animation"
                      target="_blank"
                      class={`inside-page__btn view-source-code-btn inside-page__btn--${projectsInfo.project_1.id}`}
                    >
                      NPM documentation
                    </a>
                    {/* <a
                      href="#"
                      class={`inside-page__btn inside-page__btn--${projectsInfo.project_1.id}`}
                    >
                      View Demo
                    </a> */}
                  </div>
                </div>
              </div>
            </section>

            {/* <!-- Card: Project_2 --> */}
            <section class="card-section">
              <div class="card">
                <div class="flip-card">
                  <div class="flip-card__container">
                    <div class="card-front">
                      <div
                        class={`card-front__tp card-front__tp--${projectsInfo.project_2.id}`}
                      >
                        <h2 class="card-front__heading">
                          {projectsInfo.project_2.name}
                        </h2>
                        <p class="card-front__type-text">
                          {projectsInfo.project_2.type}
                        </p>
                        <p class="card-front__stack-text">
                          {projectsInfo.project_2.stack}
                        </p>
                      </div>

                      <div class="card-front__bt">
                        <p
                          class={`card-front__text-view card-front__text-view--${projectsInfo.project_2.id}`}
                        >
                          HOVER ME
                        </p>
                      </div>
                    </div>

                    <div class="card-back">
                      <img
                        src={project_2Img}
                        alt="AddaGhor"
                        className="video__container"
                        // style={{position: 'absolute'}}
                      />
                      <a
                        href="https://addaghor.netlify.app/"
                        target="_blank"
                        class={`inside-page__btn view-demo-btn inside-page__btn--${projectsInfo.project_2.id}`}
                      >
                        Live Demo
                      </a>
                      {/* <video class="video__container" autoplay muted loop>
                                    <source class="video__media" src="https://player.vimeo.com/external/195913085.sd.mp4?s=7c12f7a83de62a8900fd2ae049297070b9bc8a54&profile_id=164&oauth2_token_id=574477611" type="video/mp4">
                                </video> */}
                    </div>
                  </div>
                </div>

                <div class="inside-page">
                  <div class="inside-page__container">
                    <h3
                      class={`inside-page__heading inside-page__heading--${projectsInfo.project_2.id}`}
                    >
                      About the App
                    </h3>
                    <p class="inside-page__text">
                      {projectsInfo.project_2.details}
                    </p>
                    <a
                      href="https://github.com/OmorFarukRakib/AddaGhor"
                      target="_blank"
                      class={`inside-page__btn view-source-code-btn inside-page__btn--${projectsInfo.project_2.id}`}
                    >
                      Source Code
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* <!-- Card: Project_3 --> */}
            <section class="card-section">
              <div class="card">
                <div class="flip-card">
                  <div class="flip-card__container">
                    <div class="card-front">
                      <div
                        class={`card-front__tp card-front__tp--${projectsInfo.project_3.id}`}
                      >
                        <h2 class="card-front__heading">
                          {projectsInfo.project_3.name}
                        </h2>
                        <p class="card-front__type-text">
                          {projectsInfo.project_3.type}
                        </p>
                        <p class="card-front__stack-text">
                          {projectsInfo.project_3.stack}
                        </p>
                      </div>

                      <div class="card-front__bt">
                        <p
                          class={`card-front__text-view card-front__text-view--${projectsInfo.project_3.id}`}
                        >
                          HOVER ME
                        </p>
                      </div>
                    </div>

                    <div class="card-back">
                      <img
                        src={project_3Img}
                        alt="Snake Game"
                        className="video__container"
                        // style={{position: 'absolute'}}
                      />
                      <a
                        href="https://omorfarukrakib.github.io/Snake-Game/"
                        target="_blank"
                        class={`inside-page__btn view-demo-btn inside-page__btn--${projectsInfo.project_3.id}`}
                      >
                        View Demo
                      </a>
                      {/* <video class="video__container" autoplay muted loop>
                                    <source class="video__media" src="https://player.vimeo.com/external/195913085.sd.mp4?s=7c12f7a83de62a8900fd2ae049297070b9bc8a54&profile_id=164&oauth2_token_id=574477611" type="video/mp4">
                                </video> */}
                    </div>
                  </div>
                </div>

                <div class="inside-page">
                  <div class="inside-page__container">
                    <h3
                      class={`inside-page__heading inside-page__heading--${projectsInfo.project_3.id}`}
                    >
                      About the game
                    </h3>
                    <p class="inside-page__text">
                      {projectsInfo.project_3.details}
                    </p>
                    <a
                      href="https://github.com/OmorFarukRakib/Snake-Game"
                      target="_blank"
                      class={`inside-page__btn view-source-code-btn inside-page__btn--${projectsInfo.project_3.id}`}
                    >
                      Source Code
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* <!-- Card: Project_4 --> */}
            <section class="card-section">
              <div class="card">
                <div class="flip-card">
                  <div class="flip-card__container">
                    <div class="card-front">
                      <div
                        class={`card-front__tp card-front__tp--${projectsInfo.project_4.id}`}
                      >
                        <h2 class="card-front__heading">
                          {projectsInfo.project_4.name}
                        </h2>
                        <p class="card-front__type-text">
                          {projectsInfo.project_4.type}
                        </p>
                        <p class="card-front__stack-text">
                          {projectsInfo.project_4.stack}
                        </p>
                      </div>

                      <div class="card-front__bt">
                        <p
                          class={`card-front__text-view card-front__text-view--${projectsInfo.project_4.id}`}
                        >
                          HOVER ME
                        </p>
                      </div>
                    </div>

                    <div class="card-back">
                      <img
                        src={project_4Img}
                        alt="BanglaWordPrediction"
                        className="video__container"
                        // style={{position: 'absolute'}}
                      />
                      <a
                        href="https://ieeexplore.ieee.org/document/9068063"
                        target="_blank"
                        class={`inside-page__btn view-demo-btn inside-page__btn--${projectsInfo.project_4.id}`}
                      >
                        Research Paper
                      </a>
                      {/* <video class="video__container" autoplay muted loop>
                                    <source class="video__media" src="https://player.vimeo.com/external/195913085.sd.mp4?s=7c12f7a83de62a8900fd2ae049297070b9bc8a54&profile_id=164&oauth2_token_id=574477611" type="video/mp4">
                                </video> */}
                    </div>
                  </div>
                </div>

                <div class="inside-page">
                  <div class="inside-page__container">
                    <h3
                      class={`inside-page__heading inside-page__heading--${projectsInfo.project_4.id}`}
                    >
                      About the Project
                    </h3>
                    <p class="inside-page__text">
                      {projectsInfo.project_4.details}
                    </p>
                    <a
                      href="https://github.com/OmorFarukRakib/Bangla-Word-Prediction-System"
                      target="_blank"
                      class={`inside-page__btn view-source-code-btn inside-page__btn--${projectsInfo.project_4.id}`}
                    >
                      Source Code
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* <!-- Card: Project_5 --> */}
            <section class="card-section">
              <div class="card">
                <div class="flip-card">
                  <div class="flip-card__container">
                    <div class="card-front">
                      <div
                        class={`card-front__tp card-front__tp--${projectsInfo.project_5.id}`}
                      >
                        <h2 class="card-front__heading">
                          {projectsInfo.project_5.name}
                        </h2>
                        <p class="card-front__type-text">
                          {projectsInfo.project_5.type}
                        </p>
                        <p class="card-front__stack-text">
                          {projectsInfo.project_5.stack}
                        </p>
                      </div>

                      <div class="card-front__bt">
                        <p
                          class={`card-front__text-view card-front__text-view--${projectsInfo.project_5.id}`}
                        >
                          HOVER ME
                        </p>
                      </div>
                    </div>

                    <div class="card-back">
                      <img
                        src={project_5Img}
                        alt="ImageSearchGallery"
                        className="video__container"
                        // style={{position: 'absolute'}}
                      />
                      <a
                        href="https://omorfarukrakib.github.io/Image-Searching-Gallery/"
                        target="_blank"
                        class={`inside-page__btn view-demo-btn inside-page__btn--${projectsInfo.project_5.id}`}
                      >
                        Live Demo
                      </a>
                      {/* <video class="video__container" autoplay muted loop>
                                    <source class="video__media" src="https://player.vimeo.com/external/195913085.sd.mp4?s=7c12f7a83de62a8900fd2ae049297070b9bc8a54&profile_id=164&oauth2_token_id=574477611" type="video/mp4">
                                </video> */}
                    </div>
                  </div>
                </div>

                <div class="inside-page">
                  <div class="inside-page__container">
                    <h3
                      class={`inside-page__heading inside-page__heading--${projectsInfo.project_5.id}`}
                    >
                      About the Project
                    </h3>
                    <p class="inside-page__text">
                      {projectsInfo.project_5.details}
                    </p>
                    <a
                      href="https://github.com/OmorFarukRakib/Image-Searching-Gallery"
                      target="_blank"
                      class={`inside-page__btn view-source-code-btn inside-page__btn--${projectsInfo.project_5.id}`}
                    >
                      Source Code
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* <!-- Card: Project_ --> */}
            <section class="card-section">
              <div class="card">
                <div class="flip-card">
                  <div class="flip-card__container">
                    <div class="card-front">
                      <div
                        class={`card-front__tp card-front__tp--${projectsInfo.project_6.id}`}
                      >
                        <h2 class="card-front__heading">
                          {projectsInfo.project_6.name}
                        </h2>
                        <p class="card-front__type-text">
                          {projectsInfo.project_6.type}
                        </p>
                        <p class="card-front__stack-text">
                          {projectsInfo.project_6.stack}
                        </p>
                      </div>

                      <div class="card-front__bt">
                        <p
                          class={`card-front__text-view card-front__text-view--${projectsInfo.project_6.id}`}
                        >
                          HOVER ME
                        </p>
                      </div>
                    </div>

                    <div class="card-back">
                      <img
                        src={project_5Img}
                        alt="ImageSearchGallery"
                        className="video__container"
                        // style={{position: 'absolute'}}
                      />
                      <a
                        href="https://omorfarukrakib.github.io/Image-Searching-Gallery/"
                        target="_blank"
                        class={`inside-page__btn view-demo-btn inside-page__btn--${projectsInfo.project_6.id}`}
                      >
                        Live Demo
                      </a>
                      {/* <video class="video__container" autoplay muted loop>
                                    <source class="video__media" src="https://player.vimeo.com/external/195913085.sd.mp4?s=7c12f7a83de62a8900fd2ae049297070b9bc8a54&profile_id=164&oauth2_token_id=574477611" type="video/mp4">
                                </video> */}
                    </div>
                  </div>
                </div>

                <div class="inside-page">
                  <div class="inside-page__container">
                    <h3
                      class={`inside-page__heading inside-page__heading--${projectsInfo.project_6.id}`}
                    >
                      About the Project
                    </h3>
                    <p class="inside-page__text">
                      {projectsInfo.project_6.details}
                    </p>
                    <a
                      href="https://github.com/OmorFarukRakib/Image-Searching-Gallery"
                      target="_blank"
                      class={`inside-page__btn view-source-code-btn inside-page__btn--${projectsInfo.project_6.id}`}
                    >
                      Source Code
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </section>
          {/* <footer class="footer">
            <p class="footer-text">&copy; 2021 Created by Maza designDev</p>
          </footer> */}
        </main>
          <div className="project-etc">
            I have done some Major Projects that I cant disclose due to
            confidentiality.
          </div>
      </>
    );
}

export default ProjectInfoLayout;